import ChartsService from './Base';

class SacSurveys extends ChartsService {
  constructor() {
    super('sac-surveys');
  }
}

export default new SacSurveys();
